import { render } from "./XinbActive.vue?vue&type=template&id=10c6b0d3&scoped=true"
import script from "./XinbActive.vue?vue&type=script&lang=js"
export * from "./XinbActive.vue?vue&type=script&lang=js"

import "./XinbActive.vue?vue&type=style&index=0&id=10c6b0d3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10c6b0d3"]])

export default __exports__